

// // Custmizemenu.js
// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaPlus, FaFileExport, FaFileImport, FaFilter, FaTimes, FaImage, FaTag, FaRupeeSign, FaPercent, FaAlignLeft, FaUtensils, FaLeaf, FaGlassCheers } from "react-icons/fa";
// import Modal from "react-modal";
// import * as XLSX from "xlsx";
// import "./Custmizemenu.css";
// import DEFAULT_IMAGE from "./food.jpg";
// import {
//     getMenuByVendor,
// } from "../../../../Component/Servicefile/Menuapiservice";

// Modal.setAppElement("#root");

// // Dummy data for loading state
// const DUMMY_MENU = [
//     {
//         id: 1,
//         name: "Appetizers",
//         description: "Start your meal with these delicious appetizers",
//         price: 0,
//         parentId: null,
//         image: DEFAULT_IMAGE,
//         discount: 0,
//         effectivePrice: 0,
//         available: true,
//         dishType: "Veg",
//         category: "Appetizers",
//         chefType: "-",
//         gst: "-",
//         isDummy: true
//     },
//     {
//         id: 2,
//         name: "Main Course",
//         description: "Hearty and satisfying main dishes",
//         price: 0,
//         parentId: null,
//         image: DEFAULT_IMAGE,
//         discount: 0,
//         effectivePrice: 0,
//         available: true,
//         dishType: "Non_veg",
//         category: "Main Course",
//         chefType: "-",
//         gst: "-",
//         isDummy: true
//     },
//     {
//         id: 3,
//         name: "Beverages",
//         description: "Refreshing drinks to complement your meal",
//         price: 0,
//         parentId: null,
//         image: DEFAULT_IMAGE,
//         discount: 0,
//         effectivePrice: 0,
//         available: true,
//         dishType: "Drinks",
//         category: "Beverages",
//         chefType: "-",
//         gst: "-",
//         isDummy: true
//     },


// ];

// export default function Cateringcustomizemenu() {
//     const [isQuickModal, setIsQuickModal] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [menu, setMenu] = useState(DUMMY_MENU); // Start with dummy data
//     const [isVegSelected, setIsVegSelected] = useState(null);
//     const [loading, setLoading] = useState(true); // Start loading true
//     const [error, setError] = useState("");
//     const [filteredMenu, setFilteredMenu] = useState(DUMMY_MENU);
//     const [isSaving, setIsSaving] = useState(false);
//     const [isDataLoaded, setIsDataLoaded] = useState(false);

//     const [quickForm, setQuickForm] = useState({
//         name: "",
//         image: null,
//         type: "veg",
//     });

//     const [isDetailModal, setIsDetailModal] = useState(false);
//     const [editRowId, setEditRowId] = useState(null);
//     const [detailForm, setDetailForm] = useState({
//         name: "",
//         category: "",
//         price: "",
//         quantity: "",
//         consumed: "",
//         chefType: "",
//         type: "veg",
//         image: null,
//     });
//     const [isEditModal, setIsEditModal] = useState(false);
//     const [editForm, setEditForm] = useState({
//         id: null,
//         name: "",
//         category: "",
//         price: "",
//         discount: "",
//         description: "",
//         type: "veg",
//         image: null
//     });

//     const handleAddClick = (item) => {
//         setIsDetailModal(true);
//         setEditRowId(item.dishId || item.id);
//         setDetailForm({
//             name: "",
//             category: "",
//             price: "",
//             discount: "",
//             description: "",
//             image: null,
//             type: "veg"
//         });
//     };

//     const handleEditSave = async () => {
//         try {
//             const authToken = localStorage.getItem("authToken");
//             if (!authToken) throw new Error("No auth token found. Please login.");

//             const dishPayload = {
//                 dishId: editForm.id,
//                 dishName: editForm.name,
//                 dishDescription: editForm.description || editForm.category || "",
//                 dishPrice: Number(editForm.price),
//                 parentId: editForm.parentId || 0,
//                 discountPercentage: Number(editForm.discount || 0),
//                 effectivePrice: Number(editForm.effectivePrice || 0),
//                 dishType:
//                     editForm.type === "veg"
//                         ? "Veg"
//                         : editForm.type === "nonveg"
//                             ? "Non_veg"
//                             : "Drinks",
//                 available: editForm.available ?? true,
//             };

//             const formData = new FormData();
//             formData.append("dishData", new Blob([JSON.stringify(dishPayload)], { type: "application/json" }));

//             if (editForm.image instanceof File) {
//                 formData.append("image", editForm.image);
//             }

//             const response = await fetch(
//                 `https://backend.maamaas.com/catering/api/admin/${editForm.id}`,
//                 {
//                     method: "PUT",
//                     headers: { Authorization: `Bearer ${authToken}` },
//                     body: formData,
//                 }
//             );

//             const text = await response.text();

//             if (!response.ok) throw new Error(`PUT error! Status: ${response.status} | ${text}`);

//             const updatedItem = JSON.parse(text);

//             setMenu(prev =>
//                 prev.map(item =>
//                     item.id === updatedItem.dishId
//                         ? {
//                             ...item,
//                             name: updatedItem.dishName,
//                             description: updatedItem.dishDescription,
//                             price: updatedItem.dishPrice,
//                             dishType: updatedItem.dishType,
//                             image: updatedItem.dishImage
//                                 ? updatedItem.dishImage + "?t=" + new Date().getTime()
//                                 : item.image,
//                             discount: updatedItem.discountPercentage,
//                             effectivePrice: updatedItem.effectivePrice,
//                             available: updatedItem.available,
//                             isDummy: false
//                         }
//                         : item
//                 )
//             );

//             setFilteredMenu(prev =>
//                 prev.map(item =>
//                     item.id === updatedItem.dishId
//                         ? {
//                             ...item,
//                             image: updatedItem.dishImage
//                                 ? updatedItem.dishImage + "?t=" + new Date().getTime()
//                                 : item.image,
//                             isDummy: false
//                         }
//                         : item
//                 )
//             );

//             alert("✅ Item updated successfully!");
//             setIsEditModal(false);
//         } catch (err) {
//             console.error("Failed to update item:", err);
//             alert("Failed to update item: " + (err.message || "Unknown error"));
//         }
//     };

//     const handleImport = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         const authToken = localStorage.getItem("authToken");
//         if (!authToken) {
//             alert("No auth token found. Please login again.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("file", file);

//         try {
//             const response = await fetch(
//                 "https://backend.maamaas.com/catering/api/admin/import",
//                 {
//                     method: "POST",
//                     headers: {
//                         Authorization: `Bearer ${authToken}`,
//                         Accept: "*/*",
//                     },
//                     body: formData,
//                 }
//             );

//             const text = await response.text();

//             if (!response.ok) {
//                 throw new Error(`HTTP ${response.status} - ${text}`);
//             }

//             const result = JSON.parse(text);
//             alert("✅ Menu imported successfully from Excel!");

//             if (Array.isArray(result)) {
//                 const formattedResult = result.map(item => ({
//                     ...item,
//                     isDummy: false
//                 }));
//                 setMenu((prev) => [...prev, ...formattedResult]);
//                 setFilteredMenu((prev) => [...prev, ...formattedResult]);
//             }

//         } catch (error) {
//             console.error("🚨 Import failed:", error);
//             alert("❌ Import failed: " + (error.message || "Unknown error"));
//         } finally {
//             event.target.value = "";
//         }
//     };

//     const handleEditChange = (e) => {
//         const { name, files, value } = e.target;

//         if (name === "image" && files && files[0]) {
//             setEditForm(prev => ({ ...prev, image: files[0] }));
//         } else {
//             setEditForm(prev => ({ ...prev, [name]: value }));
//         }
//     };

//     const handleDetailSave = async () => {
//         try {
//             setIsSaving(true);

//             const authToken = localStorage.getItem("authToken");
//             if (!authToken) throw new Error("No auth token found. Please login.");

//             const dishData = {
//                 dishId: 0,
//                 dishName: detailForm.name || "",
//                 dishDescription: detailForm.description || detailForm.category || "",
//                 dishPrice: Number(detailForm.price || 0),
//                 parentId: editRowId,
//                 discountPercentage: Number(detailForm.discount || 0),
//                 effectivePrice:
//                     Number(detailForm.price || 0) -
//                     (Number(detailForm.price || 0) * Number(detailForm.discount || 0)) / 100,
//                 available: true,
//                 dishType:
//                     detailForm.type === "veg"
//                         ? "Veg"
//                         : detailForm.type === "nonveg"
//                             ? "Non_veg"
//                             : "Drinks",
//             };

//             const formDataToSend = new FormData();
//             formDataToSend.append(
//                 "dishData",
//                 new Blob([JSON.stringify(dishData)], { type: "application/json" })
//             );

//             if (detailForm.image instanceof File) {
//                 formDataToSend.append("image", detailForm.image);
//             }

//             const response = await fetch(
//                 "https://backend.maamaas.com/catering/api/admin/dishes",
//                 {
//                     method: "POST",
//                     headers: {
//                         Authorization: `Bearer ${authToken}`,
//                     },
//                     body: formDataToSend,
//                 }
//             );

//             const text = await response.text();

//             if (!response.ok) {
//                 throw new Error(text);
//             }

//             const savedDish = JSON.parse(text);
//             alert("✅ Subcategory added successfully!");

//             const newItem = {
//                 ...detailForm,
//                 id: savedDish.dishId,
//                 image: detailForm.image,
//                 isDummy: false
//             };
//             setMenu(prev => [...prev, newItem]);
//             setFilteredMenu(prev => [...prev, newItem]);

//             setDetailForm({
//                 name: "",
//                 category: "",
//                 price: "",
//                 discount: "",
//                 description: "",
//                 image: null,
//                 type: "veg",
//             });
//             setIsDetailModal(false);
//         } catch (err) {
//             console.error("❌ Failed to save subcategory:", err);
//             alert("❌ Failed to save subcategory: " + (err.message || "Unknown error"));
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     const getValidImageUrl = (url) => {
//         if (!url) return DEFAULT_IMAGE;

//         try {
//             if (url.startsWith("data:image/")) return url;

//             let decoded = decodeURIComponent(url);

//             if (decoded.startsWith("http://localhost:9000/caterings/http")) {
//                 const parts = decoded.split("http://localhost:9000/caterings/");
//                 decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
//             }

//             return decoded;
//         } catch (err) {
//             console.error("Error parsing image URL:", err);
//             return DEFAULT_IMAGE;
//         }
//     };

//     const handleDetailChange = (e) => {
//         const { name, value, files } = e.target;

//         if (name === "image") {
//             setDetailForm(prev => ({ ...prev, image: files[0] || null }));
//         } else {
//             setDetailForm(prev => ({ ...prev, [name]: value }));
//         }
//     };

//     const fetchImageBlob = async (url) => {
//         try {
//             const response = await fetch(url);
//             if (!response.ok) throw new Error("Failed to fetch image");
//             const blob = await response.blob();
//             return URL.createObjectURL(blob);
//         } catch (err) {
//             console.error(err);
//             return DEFAULT_IMAGE;
//         }
//     };

//     useEffect(() => {
//         const fetchMenu = async () => {
//             setLoading(true);
//             setError(null);
//             try {
//                 const data = await getMenuByVendor();

//                 if (data && data.length > 0) {
//                     const formattedMenu = await Promise.all(
//                         data.map(async (item) => {
//                             let imageUrl = getValidImageUrl(item.dishImage);

//                             if (!imageUrl.startsWith("data:image/")) {
//                                 imageUrl = await fetchImageBlob(imageUrl);
//                             }

//                             return {
//                                 id: item.dishId,
//                                 name: item.dishName,
//                                 description: item.dishDescription,
//                                 price: item.dishPrice,
//                                 parentId: item.parentId,
//                                 image: imageUrl,
//                                 discount: item.discountPercentage,
//                                 effectivePrice: item.effectivePrice,
//                                 available: item.available,
//                                 dishType: item.dishType || "-",
//                                 category: item.category || "-",
//                                 chefType: item.chefType || "-",
//                                 gst: item.gst || "-",
//                                 isDummy: false
//                             };
//                         })
//                     );

//                     setMenu(formattedMenu);
//                     setFilteredMenu(formattedMenu);
//                     setIsDataLoaded(true);
//                 } else {
//                     // Keep dummy data if no real data
//                     setMenu(DUMMY_MENU);
//                     setFilteredMenu(DUMMY_MENU);
//                     setIsDataLoaded(false);
//                 }
//             } catch (err) {
//                 console.error("Error fetching menu:", err);
//                 setError("Failed to load menu. Showing sample data.");
//                 // Keep dummy data on error
//                 setMenu(DUMMY_MENU);
//                 setFilteredMenu(DUMMY_MENU);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMenu();
//     }, []);

//     useEffect(() => {
//         localStorage.setItem("menuData", JSON.stringify(menu));
//     }, [menu]);

//    const handleQuickSave = async () => {
//     if (!quickForm.name) {
//         alert("Enter category name!");
//         return;
//     }

//     setIsLoading(true);

//     try {
//         const token = localStorage.getItem("authToken");
//         if (!token) throw new Error("No auth token found");

//         // ✅ Category payload - parentId: 0
//         const dishData = {
//             dishName: quickForm.name,
//             dishDescription: quickForm.description || "",
//             dishPrice: 0,
//             parentId: 0,
//             discountPercentage: 0,
//             dishType: quickForm.type || "Veg", // ✅ Veg, Non_veg, or Drinks
//             available: true
//         };

//         const formDataToSend = new FormData();
//         formDataToSend.append(
//             "dishData",
//             new Blob([JSON.stringify(dishData)], { type: "application/json" })
//         );

//         if (quickForm.image instanceof File) {
//             formDataToSend.append("image", quickForm.image);
//         }

//         const response = await fetch(
//             `https://backend.maamaas.com/catering/api/admin/dishes`,
//             {
//                 method: "POST",
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//                 body: formDataToSend,
//             }
//         );

//         const text = await response.text();
//         if (!response.ok) throw new Error(text);

//         const savedDish = JSON.parse(text);
//         alert("✅ Category added successfully!");

//         const newItem = {
//             ...quickForm,
//             id: savedDish.dishId,
//             parentId: 0,
//             image: quickForm.image || DEFAULT_IMAGE,
//             dishType: quickForm.type || "Veg",
//             isDummy: false
//         };
//         setMenu(prev => [...prev, newItem]);
//         setFilteredMenu(prev => [...prev, newItem]);

//         setQuickForm({ name: "", price: "", image: null, dishType: "Veg", description: "" });
//         setIsQuickModal(false);
//     } catch (error) {
//         console.error("❌ Error adding category:", error);
//         alert(`❌ Failed to add category: ${error.message}`);
//     } finally {
//         setIsLoading(false);
//     }
// };

//     const handleQuickChange = (e) => {
//     const { name, files, value } = e.target;
//     if (name === "image" && files && files[0]) {
//         setQuickForm(prev => ({ ...prev, image: files[0] }));
//     } else {
//         setQuickForm(prev => ({ ...prev, [name]: value }));
//     }
// };

//     const handleDelete = async (id) => {
//         // Check if it's a dummy item
//         const item = menu.find(item => item.id === id);
//         if (item?.isDummy) {
//             alert("This is sample data. Please add your own items to manage.");
//             return;
//         }

//         if (!window.confirm("Are you sure you want to delete this item?")) return;

//         try {
//             setIsSaving(true);

//             const authToken = localStorage.getItem("authToken");
//             if (!authToken) throw new Error("No auth token found. Please login.");

//             const response = await fetch(
//                 `https://backend.maamaas.com/catering/api/admin/delete/${id}`,
//                 {
//                     method: "DELETE",
//                     headers: {
//                         "Accept": "*/*",
//                         Authorization: `Bearer ${authToken}`
//                     }
//                 }
//             );

//             if (!response.ok) {
//                 const text = await response.text();
//                 throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
//             }

//             alert("Item deleted successfully!");

//             setMenu(prev => prev.filter(item => item.id !== id));
//             setFilteredMenu(prev => prev.filter(item => item.id !== id));
//         } catch (err) {
//             console.error("Failed to delete item:", err);
//             alert("Failed to delete item: " + (err.message || "Unknown error"));
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     const handleEdit = (item) => {
//         setEditForm({
//             id: item.id,
//             name: item.name || "",
//             category: item.category || "",
//             price: item.price || "",
//             discount: item.discount || "",
//             description: item.description || "",
//             image: item.image || null,
//             type: item.dishType === "Veg" ? "veg" : item.dishType === "Non_veg" ? "nonveg" : "drinks",
//         });
//         setIsEditModal(true);
//     };

//     const handleExport = () => {
//         const ws = XLSX.utils.json_to_sheet(menu.filter(item => !item.isDummy));
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Menu");
//         XLSX.writeFile(wb, "menu.xlsx");
//     };

//     const handleFilterClick = (type) => {
//         if (type === "Veg") {
//             const mainCategories = filteredMenu.filter(item => !item.parentId);
//             const vegSubcategories = filteredMenu.filter(item =>
//                 item.parentId &&
//                 item.dishType?.toLowerCase() === "veg"
//             );

//             const filtered = [];
//             mainCategories.forEach(mainCat => {
//                 filtered.push(mainCat);
//                 const matchingSubs = vegSubcategories.filter(sub => sub.parentId === mainCat.id);
//                 filtered.push(...matchingSubs);
//             });

//             setFilteredMenu(filtered);
//             setIsVegSelected("veg");
//         } else if (type === "Non-Veg") {
//             const mainCategories = filteredMenu.filter(item => !item.parentId);
//             const nonVegSubcategories = filteredMenu.filter(item =>
//                 item.parentId &&
//                 (item.dishType?.toLowerCase() === "non-veg" ||
//                     item.dishType?.toLowerCase() === "nonveg" ||
//                     item.dishType?.toLowerCase() === "non_veg")
//             );

//             const filtered = [];
//             mainCategories.forEach(mainCat => {
//                 filtered.push(mainCat);
//                 const matchingSubs = nonVegSubcategories.filter(sub => sub.parentId === mainCat.id);
//                 filtered.push(...matchingSubs);
//             });

//             setFilteredMenu(filtered);
//             setIsVegSelected("nonveg");
//         } else if (type === "Drinks") {
//             const mainCategories = filteredMenu.filter(item => !item.parentId);
//             const drinksSubcategories = filteredMenu.filter(item =>
//                 item.parentId &&
//                 item.dishType?.toLowerCase() === "drinks"
//             );

//             const filtered = [];
//             mainCategories.forEach(mainCat => {
//                 filtered.push(mainCat);
//                 const matchingSubs = drinksSubcategories.filter(sub => sub.parentId === mainCat.id);
//                 filtered.push(...matchingSubs);
//             });

//             setFilteredMenu(filtered);
//             setIsVegSelected("drinks");
//         } else {
//             setFilteredMenu(menu);
//             setIsVegSelected(null);
//         }
//     };

//     const getFilterButtonText = () => {
//         if (isVegSelected === null) return "All Types";
//         if (isVegSelected === "veg") return "🌿 Veg";
//         if (isVegSelected === "nonveg") return "🍗 Non-Veg";
//         if (isVegSelected === "drinks") return "🥤 Drinks";
//         return "All Types";
//     };

//     const getFilterButtonColor = () => {
//         if (isVegSelected === null) return "#6c757d";
//         if (isVegSelected === "veg") return "#28a745";
//         if (isVegSelected === "nonveg") return "#dc3545";
//         if (isVegSelected === "drinks") return "#17a2b8";
//         return "#6c757d";
//     };

//     const getNextFilterType = () => {
//         if (isVegSelected === null) return "Veg";
//         if (isVegSelected === "veg") return "Non-Veg";
//         if (isVegSelected === "nonveg") return "Drinks";
//         if (isVegSelected === "drinks") return "All";
//         return "Veg";
//     };

//     const getDishTypeIcon = (type) => {
//         if (type?.toLowerCase() === "veg") return <FaLeaf className="type-icon veg-icon" />;
//         if (type?.toLowerCase() === "non_veg" || type?.toLowerCase() === "nonveg") return <FaGlassCheers className="type-icon nonveg-icon" />;
//         if (type?.toLowerCase() === "drinks") return <FaGlassCheers className="type-icon drinks-icon" />;
//         return null;
//     };

//     // Check if we're showing dummy data
//     const isShowingDummy = menu.some(item => item.isDummy) && !isDataLoaded;

//     return (
//         <div className="catering-menu-container">
//             {/* <div className="menu-header">
//                 <h1 className="menu-title">
//                     <FaUtensils className="title-icon" />
//                     Catering Menu Management
//                 </h1>
//                 <p className="menu-subtitle">
//                     {isShowingDummy ? "📋 Sample Menu (Add your items below)" : "Manage your dishes, categories, and subcategories"}
//                 </p>
//             </div> */}

//             <div className="menu-controls">
//                 <div className="controls-left">
//                     <button className="btn-primary" onClick={() => setIsQuickModal(true)}>
//                         <FaPlus className="btn-icon" /> Add Category
//                     </button>
//                     <button
//                         className="btn-filter"
//                         onClick={() => handleFilterClick(getNextFilterType())}
//                         style={{ backgroundColor: getFilterButtonColor() }}
//                     >
//                         <FaFilter className="btn-icon" /> {getFilterButtonText()}
//                     </button>
//                 </div>
//                 <div className="controls-right">
//                     <button className="btn-export" onClick={handleExport}>
//                         <FaFileExport className="btn-icon" /> Export
//                     </button>
//                     <label className="btn-import">
//                         <FaFileImport className="btn-icon" /> Import
//                         <input type="file" hidden onChange={handleImport} />
//                     </label>
//                 </div>
//             </div>

//             {loading ? (
//                 <div className="loading-container">
//                     <div className="spinner"></div>
//                     <p>Loading your menu...</p>
//                 </div>
//             ) : (
//                 <div className="table-container">
//                     {/* {isShowingDummy && (
//                         <div className="dummy-banner">
//                             <span>ℹ️ Showing sample menu. Your real menu will appear here when available.</span>
//                         </div>
//                     )} */}
//                     <table className="menu-table">
//                         <thead>
//                             <tr>
//                                 <th className="col-sno">#</th>
//                                 <th className="col-name">Category / Subcategory</th>
//                                 <th className="col-image">Image</th>
//                                 <th className="col-type">Type</th>
//                                 <th className="col-price">Price</th>
//                                 <th className="col-discount">Discount</th>
//                                 <th className="col-description">Description</th>
//                                 <th className="col-actions">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredMenu
//                                 .filter(item => !item.parentId)
//                                 .map((item, index) => (
//                                     <React.Fragment key={item.id}>
//                                         <tr className={`category-row ${item.isDummy ? 'dummy-row' : ''}`}>
//                                             <td className="col-sno">{index + 1}</td>
//                                             <td className="col-name">
//                                                 <span className="category-name">{item.name}</span>
//                                                 {item.isDummy && <span className="dummy-badge">Sample</span>}
//                                             </td>
//                                             <td className="col-image">
//                                                 <img
//                                                     src={getValidImageUrl(item.image)}
//                                                     alt={item.name}
//                                                     className="item-image"
//                                                 />
//                                             </td>
//                                             <td className="col-type">
//                                                 {getDishTypeIcon(item.dishType)}
//                                                 <span>{item.dishType}</span>
//                                             </td>
//                                             <td className="col-price">-</td>
//                                             <td className="col-discount">-</td>
//                                             <td className="col-description">{item.description || '-'}</td>
//                                             <td className="col-actions">
//                                                 <button className="btn-add-sub" onClick={() => handleAddClick(item)}>
//                                                     <FaPlus className="btn-icon-small" /> Add Sub
//                                                 </button>
//                                                 <button className="btn-edit" onClick={() => handleEdit(item)}>
//                                                     <FaEdit />
//                                                 </button>
//                                                 <button className="btn-delete" onClick={() => handleDelete(item.id)}>
//                                                     <FaTrash />
//                                                 </button>
//                                             </td>
//                                         </tr>

//                                         {filteredMenu
//                                             .filter(sub => sub.parentId === item.id)
//                                             .map((subItem, subIndex) => (
//                                                 <tr key={subItem.id} className={`subcategory-row ${subItem.isDummy ? 'dummy-row' : ''}`}>
//                                                     <td className="col-sno">{index + 1}.{subIndex + 1}</td>
//                                                     <td className="col-name">
//                                                         <span className="subcategory-indent">↳</span>
//                                                         <span className="subcategory-name">{subItem.name}</span>
//                                                         {subItem.isDummy && <span className="dummy-badge">Sample</span>}
//                                                     </td>
//                                                     <td className="col-image">
//                                                         <img
//                                                             src={getValidImageUrl(subItem.image)}
//                                                             alt={subItem.name}
//                                                             className="item-image"
//                                                         />
//                                                     </td>
//                                                     <td className="col-type">
//                                                         {getDishTypeIcon(subItem.dishType)}
//                                                         <span>{subItem.dishType}</span>
//                                                     </td>
//                                                     <td className="col-price">₹{subItem.price}</td>
//                                                     <td className="col-discount">{subItem.discount}%</td>
//                                                     <td className="col-description">{subItem.description || '-'}</td>
//                                                     <td className="col-actions">
//                                                         <button className="btn-edit" onClick={() => handleEdit(subItem)}>
//                                                             <FaEdit />
//                                                         </button>
//                                                         <button className="btn-delete" onClick={() => handleDelete(subItem.id)}>
//                                                             <FaTrash />
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                     </React.Fragment>
//                                 ))}

//                             {filteredMenu.filter(item => !item.parentId).length === 0 && (
//                                 <tr>
//                                     <td colSpan="8" className="empty-state">
//                                         <p>No items found. Click "Add Category" to get started.</p>
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* Modals remain the same */}
//             <Modal
//                 isOpen={isQuickModal}
//                 onRequestClose={() => setIsQuickModal(false)}
//                 className="modal-contentxy"
//                 overlayClassName="modal-overlayxy"
//             >
//                 <div className="modal-header">
//                     <h2><FaPlus className="modal-icon" /> Add New Category</h2>
//                     <button className="modal-close" onClick={() => setIsQuickModal(false)}>
//                         <FaTimes />
//                     </button>
//                 </div>
//                 <div className="modal-body">
//                     <div className="form-group">
//                         <label><FaTag className="input-icon" /> Category Name</label>
//                         <input
//                             type="text"
//                             name="name"
//                             placeholder="Enter category name"
//                             value={quickForm.name}
//                             onChange={handleQuickChange}
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label><FaImage className="input-icon" /> Category Image</label>
//                         <input
//                             type="file"
//                             name="image"
//                             onChange={handleQuickChange}
//                             className="form-input file-input"
//                             accept="image/*"
//                         />
//                     </div>
//                 </div>
//                 <div className="modal-footer">
//                     <button className="btn-cancel" onClick={() => setIsQuickModal(false)}>Cancel</button>
//                     <button className="btn-save" onClick={handleQuickSave} disabled={isLoading}>
//                         {isLoading ? "Adding..." : "Add Category"}
//                     </button>
//                 </div>
//             </Modal>

//             <Modal
//                 isOpen={isDetailModal}
//                 onRequestClose={() => setIsDetailModal(false)}
//                 className="modal-contentxy"
//                 overlayClassName="modal-overlayxy"
//             >
//                 <div className="modal-header">
//                     <h2><FaPlus className="modal-icon" /> Add Subcategory</h2>
//                     <button className="modal-close" onClick={() => setIsDetailModal(false)}>
//                         <FaTimes />
//                     </button>
//                 </div>
//                 <div className="modal-body">
//                     <div className="form-group">
//                         <label>Parent Category ID</label>
//                         <input
//                             type="text"
//                             name="parentId"
//                             value={editRowId || ""}
//                             readOnly
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label><FaTag className="input-icon" /> Item Name</label>
//                         <input
//                             type="text"
//                             name="name"
//                             placeholder="Enter item name"
//                             value={detailForm.name}
//                             onChange={handleDetailChange}
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group half">
//                             <label><FaRupeeSign className="input-icon" /> Price</label>
//                             <input
//                                 type="number"
//                                 name="price"
//                                 placeholder="0"
//                                 value={detailForm.price}
//                                 onChange={handleDetailChange}
//                                 className="form-input"
//                             />
//                         </div>
//                         <div className="form-group half">
//                             <label><FaPercent className="input-icon" /> Discount %</label>
//                             <input
//                                 type="number"
//                                 name="discount"
//                                 placeholder="0"
//                                 value={detailForm.discount}
//                                 onChange={handleDetailChange}
//                                 className="form-input"
//                             />
//                         </div>
//                     </div>
//                     <div className="form-group">
//                         <label><FaAlignLeft className="input-icon" /> Description</label>
//                         <input
//                             type="text"
//                             name="description"
//                             placeholder="Enter description"
//                             value={detailForm.description}
//                             onChange={handleDetailChange}
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label><FaImage className="input-icon" /> Item Image</label>
//                         <input
//                             type="file"
//                             name="image"
//                             onChange={handleDetailChange}
//                             className="form-input file-input"
//                             accept="image/*"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label>Dish Type</label>
//                         <select name="type" value={detailForm.type} onChange={handleDetailChange} className="form-input">
//                             <option value="veg">🌿 Veg</option>
//                             <option value="nonveg">🍗 Non-Veg</option>
//                             <option value="drinks">🥤 Drinks</option>
//                         </select>
//                     </div>
//                 </div>
//                 <div className="modal-footer">
//                     <button className="btn-cancel" onClick={() => setIsDetailModal(false)}>Cancel</button>
//                     <button className="btn-save" onClick={handleDetailSave} disabled={isSaving}>
//                         {isSaving ? "Saving..." : "Save Subcategory"}
//                     </button>
//                 </div>
//             </Modal>

//             <Modal
//                 isOpen={isEditModal}
//                 onRequestClose={() => setIsEditModal(false)}
//                 className="modal-contentxy"
//                 overlayClassName="modal-overlayxy"
//             >
//                 <div className="modal-header">
//                     <h2><FaEdit className="modal-icon" /> Edit Item</h2>
//                     <button className="modal-close" onClick={() => setIsEditModal(false)}>
//                         <FaTimes />
//                     </button>
//                 </div>
//                 <div className="modal-body">
//                     <div className="form-group">
//                         <label><FaTag className="input-icon" /> Item Name</label>
//                         <input
//                             type="text"
//                             name="name"
//                             placeholder="Item Name"
//                             value={editForm.name}
//                             onChange={handleEditChange}
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label>Category</label>
//                         <input
//                             type="text"
//                             name="category"
//                             placeholder="Category"
//                             value={editForm.category}
//                             onChange={handleEditChange}
//                             className="form-input"
//                         />
//                     </div>
//                     <div className="form-row">
//                         <div className="form-group half">
//                             <label><FaRupeeSign className="input-icon" /> Price</label>
//                             <input
//                                 type="number"
//                                 name="price"
//                                 placeholder="Price"
//                                 value={editForm.price}
//                                 onChange={handleEditChange}
//                                 className="form-input"
//                             />
//                         </div>
//                         <div className="form-group half">
//                             <label><FaPercent className="input-icon" /> Discount %</label>
//                             <input
//                                 type="number"
//                                 name="discount"
//                                 placeholder="Discount %"
//                                 value={editForm.discount}
//                                 onChange={handleEditChange}
//                                 className="form-input"
//                             />
//                         </div>
//                     </div>
//                     <div className="form-group">
//                         <label><FaAlignLeft className="input-icon" /> Description</label>
//                         <input
//                             type="text"
//                             name="description"
//                             placeholder="Description"
//                             value={editForm.description}
//                             onChange={handleEditChange}
//                             className="form-input"
//                         />
//                     </div>
//                     {editForm.image && !(editForm.image instanceof File) && (
//                         <div className="form-group">
//                             <label>Current Image</label>
//                             <img
//                                 src={getValidImageUrl(editForm.image)}
//                                 alt="Current"
//                                 className="current-image"
//                             />
//                         </div>
//                     )}
//                     <div className="form-group">
//                         <label><FaImage className="input-icon" /> Update Image</label>
//                         <input
//                             type="file"
//                             name="image"
//                             onChange={handleEditChange}
//                             className="form-input file-input"
//                             accept="image/*"
//                         />
//                     </div>
//                     <div className="form-group">
//                         <label>Dish Type</label>
//                         <select name="type" value={editForm.type} onChange={handleEditChange} className="form-input">
//                             <option value="veg">🌿 Veg</option>
//                             <option value="nonveg">🍗 Non-Veg</option>
//                             <option value="drinks">🥤 Drinks</option>
//                         </select>
//                     </div>
//                 </div>
//                 <div className="modal-footer">
//                     <button className="btn-cancel" onClick={() => setIsEditModal(false)}>Cancel</button>
//                     <button className="btn-save" onClick={handleEditSave}>Save Changes</button>
//                 </div>
//             </Modal>
//         </div>
//     );
// }



// Custmizemenu.js
import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus, FaFileExport, FaFileImport, FaFilter, FaTimes, FaImage, FaTag, FaRupeeSign, FaPercent, FaAlignLeft, FaUtensils, FaLeaf, FaGlassCheers, FaChevronDown, FaChevronRight } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import "./Custmizemenu.css";
import DEFAULT_IMAGE from "./food.jpg";
import { getMenu } from "../../../../Component/Servicefile/Menuapiservice";

Modal.setAppElement("#root");

// Dummy data for loading state
const DUMMY_MENU = [];

export default function Cateringcustomizemenu() {
    const [isQuickModal, setIsQuickModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState([]);
    const [isVegSelected, setIsVegSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [filteredMenu, setFilteredMenu] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [expandedCategories, setExpandedCategories] = useState({});

    const BASE_URL = process.env.REACT_APP_API_URL;

    const [quickForm, setQuickForm] = useState({
        name: "",
        description: "",
        image: null,
        type: "Veg",
    });

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [editRowId, setEditRowId] = useState(null);
    const [detailForm, setDetailForm] = useState({
        name: "",
        category: "",
        price: "",
        discount: "",
        description: "",
        type: "Veg",
        image: null,
    });

    const [isEditModal, setIsEditModal] = useState(false);
    const [editForm, setEditForm] = useState({
        id: null,
        name: "",
        category: "",
        price: "",
        discount: "",
        description: "",
        type: "Veg",
        image: null,
        parentId: 0,
        isCategory: false,
    });

    // Toggle category expansion
    const toggleCategory = (categoryId) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    };

    // Get categories (parentId === 0)
    const getCategories = () => {
        return filteredMenu.filter(item => item.parentId === 0 || item.parentId === null);
    };

    // Get dishes for a category
    const getDishesForCategory = (categoryId) => {
        return filteredMenu.filter(item => item.parentId === categoryId);
    };

    const handleAddClick = (item) => {
        setIsDetailModal(true);
        setEditRowId(item.dishId || item.id);
        setDetailForm({
            name: "",
            category: "",
            price: "",
            discount: "",
            description: "",
            image: null,
            type: "Veg",
        });
    };

    const handleEditSave = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const isCategory = editForm.parentId === 0 || editForm.parentId === null || editForm.isCategory;

            const dishPayload = {
                dishId: editForm.id,
                dishName: editForm.name,
                dishDescription: editForm.description || editForm.category || "",
                dishPrice: isCategory ? 0 : Number(editForm.price || 0),
                parentId: editForm.parentId || 0,
                discountPercentage: isCategory ? 0 : Number(editForm.discount || 0),
                effectivePrice: isCategory ? 0 : Number(editForm.effectivePrice || 0),
                dishType: editForm.type || "Veg",
                available: true,
            };

            const formData = new FormData();
            formData.append("dishData", new Blob([JSON.stringify(dishPayload)], { type: "application/json" }));

            if (editForm.image instanceof File) {
                formData.append("image", editForm.image);
            }

            const response = await fetch(
                `${BASE_URL}/catering/api/admin/${editForm.id}`,
                {
                    method: "PUT",
                    headers: { Authorization: `Bearer ${authToken}` },
                    body: formData,
                }
            );

            const text = await response.text();
            if (!response.ok) throw new Error(`PUT error! Status: ${response.status} | ${text}`);

            const updatedItem = JSON.parse(text);

            setMenu(prev =>
                prev.map(item =>
                    item.dishId === updatedItem.dishId
                        ? {
                            ...item,
                            dishName: updatedItem.dishName,
                            dishDescription: updatedItem.dishDescription,
                            dishPrice: updatedItem.dishPrice,
                            dishType: updatedItem.dishType || "Veg",
                            dishImage: updatedItem.dishImage
                                ? updatedItem.dishImage + "?t=" + new Date().getTime()
                                : item.dishImage,
                            discountPercentage: updatedItem.discountPercentage,
                            effectivePrice: updatedItem.effectivePrice,
                            available: updatedItem.available,
                            isDummy: false,
                        }
                        : item
                )
            );

            alert("✅ Item updated successfully!");
            setIsEditModal(false);
            fetchMenu();
        } catch (err) {
            console.error("Failed to update item:", err);
            alert("Failed to update item: " + (err.message || "Unknown error"));
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("No auth token found. Please login again.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(
                `${BASE_URL}/catering/api/admin/import`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        Accept: "*/*",
                    },
                    body: formData,
                }
            );

            const text = await response.text();
            if (!response.ok) {
                throw new Error(`HTTP ${response.status} - ${text}`);
            }

            const result = JSON.parse(text);
            alert("✅ Menu imported successfully from Excel!");

            if (Array.isArray(result)) {
                const formattedResult = result.map(item => ({
                    ...item,
                    isDummy: false,
                    dishId: item.dishId,
                    dishName: item.dishName,
                    dishDescription: item.dishDescription,
                    dishPrice: item.dishPrice,
                    parentId: item.parentId,
                    dishImage: item.dishImage,
                    discountPercentage: item.discountPercentage,
                    effectivePrice: item.effectivePrice,
                    dishType: item.dishType || "Veg",
                    available: item.available,
                }));
                setMenu((prev) => [...prev, ...formattedResult]);
                setFilteredMenu((prev) => [...prev, ...formattedResult]);
            }

        } catch (error) {
            console.error("🚨 Import failed:", error);
            alert("❌ Import failed: " + (error.message || "Unknown error"));
        } finally {
            event.target.value = "";
        }
    };

    const handleEditChange = (e) => {
        const { name, files, value } = e.target;

        if (name === "image" && files && files[0]) {
            setEditForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setEditForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleDetailSave = async () => {
        try {
            setIsSaving(true);

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            // ✅ Dish payload - parentId is the category ID
            const dishData = {
                dishId: 0,
                dishName: detailForm.name || "",
                dishDescription: detailForm.description || detailForm.category || "",
                dishPrice: Number(detailForm.price || 0),
                parentId: editRowId,
                discountPercentage: Number(detailForm.discount || 0),
                effectivePrice:
                    Number(detailForm.price || 0) -
                    (Number(detailForm.price || 0) * Number(detailForm.discount || 0)) / 100,
                available: true,
                dishType: detailForm.type || "Veg",
            };

            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            if (detailForm.image instanceof File) {
                formDataToSend.append("image", detailForm.image);
            }

            const response = await fetch(
                `${BASE_URL}/catering/api/admin/dishes`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();
            if (!response.ok) throw new Error(text);

            const savedDish = JSON.parse(text);
            alert("✅ Subcategory added successfully!");

            setMenu(prev => [...prev, {
                dishId: savedDish.dishId,
                dishName: detailForm.name,
                dishDescription: detailForm.description,
                dishPrice: Number(detailForm.price || 0),
                parentId: editRowId,
                dishImage: detailForm.image || null,
                discountPercentage: Number(detailForm.discount || 0),
                effectivePrice: Number(detailForm.price || 0),
                dishType: detailForm.type || "Veg",
                available: true,
                isDummy: false,
            }]);

            setDetailForm({
                name: "",
                category: "",
                price: "",
                discount: "",
                description: "",
                image: null,
                type: "Veg",
            });
            setIsDetailModal(false);
            fetchMenu();
        } catch (err) {
            console.error("❌ Failed to save subcategory:", err);
            alert("❌ Failed to save subcategory: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };

    const getValidImageUrl = (url) => {
        if (!url) return DEFAULT_IMAGE;
        if (url.startsWith("data:image/")) return url;
        if (url.startsWith("http://") || url.startsWith("https://")) return url;
        return DEFAULT_IMAGE;
    };

    const handleDetailChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            setDetailForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setDetailForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const fetchMenu = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getMenu();

            if (data && Array.isArray(data) && data.length > 0) {
                const formattedMenu = data.map((item) => ({
                    dishId: item.dishId,
                    dishName: item.dishName,
                    dishDescription: item.dishDescription || "",
                    dishPrice: item.dishPrice,
                    parentId: item.parentId,
                    dishImage: item.dishImage || null,
                    discountPercentage: item.discountPercentage || 0,
                    effectivePrice: item.effectivePrice,
                    dishType: item.dishType || "Veg",
                    available: item.available,
                    isDummy: false,
                }));

                setMenu(formattedMenu);
                setFilteredMenu(formattedMenu);
                setIsDataLoaded(true);
            } else {
                setMenu([]);
                setFilteredMenu([]);
                setIsDataLoaded(false);
            }
        } catch (err) {
            console.error("Error fetching menu:", err);
            setError("Failed to load menu.");
            setMenu([]);
            setFilteredMenu([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMenu();
    }, []);

    const handleQuickSave = async () => {
        if (!quickForm.name) {
            alert("Enter category name!");
            return;
        }

        setIsLoading(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) throw new Error("No auth token found");

            // ✅ Category payload - parentId: 0
            const dishData = {
                dishName: quickForm.name,
                dishDescription: quickForm.description || "",
                dishPrice: 0,
                parentId: 0,
                discountPercentage: 0,
                dishType: quickForm.type || "Veg",
                available: true,
            };

            const formDataToSend = new FormData();
            formDataToSend.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            if (quickForm.image instanceof File) {
                formDataToSend.append("image", quickForm.image);
            }

            const response = await fetch(
                `${BASE_URL}/catering/api/admin/dishes`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formDataToSend,
                }
            );

            const text = await response.text();
            if (!response.ok) throw new Error(text);

            const savedDish = JSON.parse(text);
            alert("✅ Category added successfully!");

            setMenu(prev => [...prev, {
                dishId: savedDish.dishId,
                dishName: quickForm.name,
                dishDescription: quickForm.description || "",
                dishPrice: 0,
                parentId: 0,
                dishImage: quickForm.image || null,
                discountPercentage: 0,
                effectivePrice: 0,
                dishType: quickForm.type || "Veg",
                available: true,
                isDummy: false,
            }]);

            setQuickForm({ name: "", description: "", image: null, type: "Veg" });
            setIsQuickModal(false);
            fetchMenu();
        } catch (error) {
            console.error("❌ Error adding category:", error);
            alert(`❌ Failed to add category: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const handleQuickChange = (e) => {
        const { name, files, value } = e.target;
        if (name === "image" && files && files[0]) {
            setQuickForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setQuickForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleDelete = async (id) => {
        const item = menu.find(item => item.dishId === id);
        if (item?.isDummy) {
            alert("This is sample data. Please add your own items to manage.");
            return;
        }

        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            setIsSaving(true);

            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found. Please login.");

            const response = await fetch(
                `${BASE_URL}/catering/api/admin/delete/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "Accept": "*/*",
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
            }

            alert("Item deleted successfully!");
            fetchMenu();
        } catch (err) {
            console.error("Failed to delete item:", err);
            alert("Failed to delete item: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
        }
    };

    const handleEdit = (item) => {
        const isCategory = item.parentId === 0 || item.parentId === null;

        setEditForm({
            id: item.dishId,
            name: item.dishName || "",
            category: item.category || "",
            price: item.dishPrice || "",
            discount: item.discountPercentage || "",
            description: item.dishDescription || "",
            image: item.dishImage || null,
            type: item.dishType || "Veg",
            parentId: item.parentId || 0,
            isCategory: isCategory,
        });
        setIsEditModal(true);
    };

    const handleExport = () => {
        const exportData = menu.filter(item => !item.isDummy).map(item => ({
            "Dish ID": item.dishId,
            "Dish Name": item.dishName,
            "Description": item.dishDescription,
            "Price": item.dishPrice,
            "Parent ID": item.parentId,
            "Type": item.dishType,
            "Discount %": item.discountPercentage,
            "Effective Price": item.effectivePrice,
            "Available": item.available ? "Yes" : "No",
        }));

        if (exportData.length === 0) {
            alert("No data to export!");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Menu");
        XLSX.writeFile(wb, "menu.xlsx");
    };

    const handleFilterClick = (type) => {
        if (type === "All") {
            setFilteredMenu(menu);
            setIsVegSelected(null);
            return;
        }

        const filtered = menu.filter(item => {
            if (item.parentId === 0 || item.parentId === null) {
                // Categories - show all
                return true;
            } else {
                // Dishes - filter by type
                if (type === "Veg") return item.dishType?.toLowerCase() === "veg";
                if (type === "Non_veg") return item.dishType?.toLowerCase() === "non_veg" || item.dishType?.toLowerCase() === "nonveg";
                if (type === "Drinks") return item.dishType?.toLowerCase() === "drinks";
                return true;
            }
        });

        setFilteredMenu(filtered);
        setIsVegSelected(type);
    };

    const getFilterButtonText = () => {
        if (isVegSelected === null) return "All Types";
        if (isVegSelected === "Veg") return "🌿 Veg";
        if (isVegSelected === "Non_veg") return "🍗 Non-Veg";
        if (isVegSelected === "Drinks") return "🥤 Drinks";
        return "All Types";
    };

    const getFilterButtonColor = () => {
        if (isVegSelected === null) return "#6c757d";
        if (isVegSelected === "Veg") return "#28a745";
        if (isVegSelected === "Non_veg") return "#dc3545";
        if (isVegSelected === "Drinks") return "#17a2b8";
        return "#6c757d";
    };

    const getNextFilterType = () => {
        if (isVegSelected === null) return "Veg";
        if (isVegSelected === "Veg") return "Non_veg";
        if (isVegSelected === "Non_veg") return "Drinks";
        if (isVegSelected === "Drinks") return "All";
        return "Veg";
    };

    const getDishTypeIcon = (type) => {
        if (type?.toLowerCase() === "veg") return <FaLeaf className="type-icon veg-icon" />;
        if (type?.toLowerCase() === "non_veg" || type?.toLowerCase() === "nonveg") return <FaUtensils className="type-icon nonveg-icon" />;
        if (type?.toLowerCase() === "drinks") return <FaGlassCheers className="type-icon drinks-icon" />;
        return null;
    };

    const renderImage = (url) => {
        const imageUrl = getValidImageUrl(url);
        if (imageUrl && imageUrl !== DEFAULT_IMAGE) {
            return (
                <img
                    src={imageUrl}
                    alt="Item"
                    className="item-image"
                    onError={(e) => { e.target.src = DEFAULT_IMAGE; }}
                />
            );
        }
        return <img src={DEFAULT_IMAGE} alt="Default" className="item-image" />;
    };

    return (
        <div className="catering-menu-container">
            <div className="menu-controls">
                <div className="controls-left">
                    <button className="btn-primary" onClick={() => setIsQuickModal(true)}>
                        <FaPlus className="btn-icon" /> Add Category
                    </button>
                    <button
                        className="btn-filter"
                        onClick={() => handleFilterClick(getNextFilterType())}
                        style={{ backgroundColor: getFilterButtonColor() }}
                    >
                        <FaFilter className="btn-icon" /> {getFilterButtonText()}
                    </button>
                </div>
                <div className="controls-right">
                    <button className="btn-export" onClick={handleExport}>
                        <FaFileExport className="btn-icon" /> Export
                    </button>
                    <label className="btn-import">
                        <FaFileImport className="btn-icon" /> Import
                        <input type="file" hidden onChange={handleImport} />
                    </label>
                </div>
            </div>

            {loading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Loading your menu...</p>
                </div>
            ) : (
                <div className="table-container">
                    <table className="menu-table">
                        <thead>
                            <tr>
                                <th className="col-sno">#</th>
                                <th className="col-name">Category / Subcategory</th>
                                <th className="col-image">Image</th>
                                <th className="col-type">Type</th>
                                <th className="col-price">Price</th>
                                <th className="col-discount">Discount</th>
                                <th className="col-description">Description</th>
                                <th className="col-actions">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getCategories().length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="empty-state">
                                        <p>No categories found. Click "Add Category" to get started.</p>
                                    </td>
                                </tr>
                            ) : (
                                getCategories().map((category, index) => {
                                    const dishes = getDishesForCategory(category.dishId);
                                    const isExpanded = expandedCategories[category.dishId];

                                    return (
                                        <React.Fragment key={category.dishId}>
                                            {/* Category Row */}
                                            <tr
                                                className="category-row"
                                                onClick={() => toggleCategory(category.dishId)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td className="col-sno">{index + 1}</td>
                                                <td className="col-name">
                                                    <span className="category-name">
                                                        {isExpanded ? <FaChevronDown className="expand-icon" /> : <FaChevronRight className="expand-icon" />}
                                                        {category.dishName}
                                                    </span>
                                                    <span className="category-count">({dishes.length} items)</span>
                                                </td>
                                                <td className="col-image">
                                                    {renderImage(category.dishImage)}
                                                </td>
                                                {/* <td className="col-type">
                                                    <span>-</span>
                                                </td>
                                                <td className="col-price">-</td>
                                                <td className="col-discount">-</td> */}
                                                <td colSpan={3}> -</td>
                                                <td className="col-description">{category.dishDescription || '-'}</td>
                                                <td className="col-actions" onClick={(e) => e.stopPropagation()}>
                                                    <button className="btn-add-sub" onClick={() => handleAddClick(category)}>
                                                        <FaPlus className="btn-icon-small" /> Add Sub
                                                    </button>
                                                    <button className="btn-edit" onClick={() => handleEdit(category)}>
                                                        <FaEdit />
                                                    </button>
                                                    <button className="btn-delete" onClick={() => handleDelete(category.dishId)}>
                                                        <FaTrash />
                                                    </button>
                                                </td>
                                            </tr>

                                            {/* Subcategory/Dish Rows - Expanded */}
                                            {isExpanded && dishes.map((dish, subIndex) => (
                                                <tr key={dish.dishId} className="subcategory-row">
                                                    <td className="col-sno">{index + 1}.{subIndex + 1}</td>
                                                    <td className="col-name">
                                                        <span className="subcategory-indent">↳</span>
                                                        <span className="subcategory-name">{dish.dishName}</span>
                                                    </td>
                                                    <td className="col-image">
                                                        {renderImage(dish.dishImage)}
                                                    </td>
                                                    <td className="col-type">
                                                        {getDishTypeIcon(dish.dishType)}
                                                        <span>{dish.dishType || "Veg"}</span>
                                                    </td>
                                                    <td className="col-price">₹{dish.dishPrice || 0}</td>
                                                    <td className="col-discount">{dish.discountPercentage || 0}%</td>
                                                    <td className="col-description">{dish.dishDescription || '-'}</td>
                                                    <td className="col-actions">
                                                        <button className="btn-edit" onClick={() => handleEdit(dish)}>
                                                            <FaEdit />
                                                        </button>
                                                        <button className="btn-delete" onClick={() => handleDelete(dish.dishId)}>
                                                            <FaTrash />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Add Category Modal */}
            <Modal
                isOpen={isQuickModal}
                onRequestClose={() => setIsQuickModal(false)}
                className="modal-contentxy"
                overlayClassName="modal-overlayxy"
            >
                <div className="modal-header">
                    <h2><FaPlus className="modal-icon" /> Add New Category</h2>
                    <button className="modal-close" onClick={() => setIsQuickModal(false)}>
                        <FaTimes />
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label><FaTag className="input-icon" /> Category Name</label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter category name"
                            value={quickForm.name}
                            onChange={handleQuickChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label><FaAlignLeft className="input-icon" /> Description</label>
                        <input
                            type="text"
                            name="description"
                            placeholder="Enter description"
                            value={quickForm.description}
                            onChange={handleQuickChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label><FaImage className="input-icon" /> Category Image</label>
                        <input
                            type="file"
                            name="image"
                            onChange={handleQuickChange}
                            className="form-input file-input"
                            accept="image/*"
                        />
                    </div>
                    <div className="form-group">
                        <label>Category Type</label>
                        <select
                            name="type"
                            value={quickForm.type || "Veg"}
                            onChange={handleQuickChange}
                            className="form-input"
                        >
                            <option value="Veg">🌿 Veg</option>
                            <option value="Non_veg">🍗 Non-Veg</option>
                            <option value="Drinks">🥤 Drinks</option>
                        </select>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-cancel" onClick={() => setIsQuickModal(false)}>Cancel</button>
                    <button className="btn-save" onClick={handleQuickSave} disabled={isLoading}>
                        {isLoading ? "Adding..." : "Add Category"}
                    </button>
                </div>
            </Modal>

            {/* Add Subcategory Modal */}
            <Modal
                isOpen={isDetailModal}
                onRequestClose={() => setIsDetailModal(false)}
                className="modal-contentxy"
                overlayClassName="modal-overlayxy"
            >
                <div className="modal-header">
                    <h2><FaPlus className="modal-icon" /> Add Subcategory</h2>
                    <button className="modal-close" onClick={() => setIsDetailModal(false)}>
                        <FaTimes />
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label>Parent Category ID</label>
                        <input
                            type="text"
                            name="parentId"
                            value={editRowId || ""}
                            readOnly
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label><FaTag className="input-icon" /> Item Name</label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter item name"
                            value={detailForm.name}
                            onChange={handleDetailChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group half">
                            <label><FaRupeeSign className="input-icon" /> Price</label>
                            <input
                                type="number"
                                name="price"
                                placeholder="0"
                                value={detailForm.price}
                                onChange={handleDetailChange}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group half">
                            <label><FaPercent className="input-icon" /> Discount </label>
                            <input
                                type="number"
                                name="discount"
                                placeholder="0"
                                value={detailForm.discount}
                                onChange={handleDetailChange}
                                className="form-input"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label><FaAlignLeft className="input-icon" /> Description</label>
                        <input
                            type="text"
                            name="description"
                            placeholder="Enter description"
                            value={detailForm.description}
                            onChange={handleDetailChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label><FaImage className="input-icon" /> Item Image</label>
                        <input
                            type="file"
                            name="image"
                            onChange={handleDetailChange}
                            className="form-input file-input"
                            accept="image/*"
                        />
                    </div>
                    <div className="form-group">
                        <label>Dish Type</label>
                        <select
                            name="type"
                            value={detailForm.type || "Veg"}
                            onChange={handleDetailChange}
                            className="form-input"
                        >
                            <option value="Veg">🌿 Veg</option>
                            <option value="Non_veg">🍗 Non-Veg</option>
                            <option value="Drinks">🥤 Drinks</option>
                        </select>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-cancel" onClick={() => setIsDetailModal(false)}>Cancel</button>
                    <button className="btn-save" onClick={handleDetailSave} disabled={isSaving}>
                        {isSaving ? "Saving..." : "Save Subcategory"}
                    </button>
                </div>
            </Modal>

            {/* Edit Modal */}
            <Modal
                isOpen={isEditModal}
                onRequestClose={() => setIsEditModal(false)}
                className="modal-contentxy"
                overlayClassName="modal-overlayxy"
            >
                <div className="modal-header">
                    <h2><FaEdit className="modal-icon" /> Edit Item</h2>
                    <button className="modal-close" onClick={() => setIsEditModal(false)}>
                        <FaTimes />
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label><FaTag className="input-icon" /> Item Name</label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Item Name"
                            value={editForm.name}
                            onChange={handleEditChange}
                            className="form-input"
                        />
                    </div>
                    <div className="form-row">
                        {!editForm.isCategory && (
                            <>
                                <div className="form-group half">
                                    <label><FaRupeeSign className="input-icon" /> Price</label>
                                    <input
                                        type="number"
                                        name="price"
                                        placeholder="Price"
                                        value={editForm.price}
                                        onChange={handleEditChange}
                                        className="form-input"
                                    />
                                </div>
                                <div className="form-group half">
                                    <label><FaPercent className="input-icon" /> Discount </label>
                                    <input
                                        type="number"
                                        name="discount"
                                        placeholder="2"
                                        value={editForm.discount}
                                        onChange={handleEditChange}
                                        className="form-input"
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="form-group">
                        <label><FaAlignLeft className="input-icon" /> Description</label>
                        <input
                            type="text"
                            name="description"
                            placeholder="Description"
                            value={editForm.description}
                            onChange={handleEditChange}
                            className="form-input"
                        />
                    </div>
                    {editForm.image && !(editForm.image instanceof File) && (
                        <div className="form-group">
                            <label>Current Image</label>
                            <img
                                src={getValidImageUrl(editForm.image)}
                                alt="Current"
                                className="current-image"
                            />
                        </div>
                    )}
                    <div className="form-group">
                        <label><FaImage className="input-icon" /> Update Image</label>
                        <input
                            type="file"
                            name="image"
                            onChange={handleEditChange}
                            className="form-input file-input"
                            accept="image/*"
                        />
                    </div>
                    <div className="form-group">
                        <label>Dish Type</label>
                        <select
                            name="type"
                            value={editForm.type || "Veg"}
                            onChange={handleEditChange}
                            className="form-input"
                        >
                            <option value="Veg">🌿 Veg</option>
                            <option value="Non_veg">🍗 Non-Veg</option>
                            <option value="Drinks">🥤 Drinks</option>
                        </select>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-cancel" onClick={() => setIsEditModal(false)}>Cancel</button>
                    <button className="btn-save" onClick={handleEditSave}>Save Changes</button>
                </div>
            </Modal>
        </div>
    );
}